import type { RdModalitySlug } from '@/services/quotes/rd-equipamentos/types';

/**
 * Rótulo pt-BR de cada modalidade de risco do RD Equipamentos.
 *
 * Vivia em `equipment-card.component.tsx`, exportado ao lado do componente —
 * o que quebra o Fast Refresh do Vite (um arquivo com componente E constante
 * recarrega o módulo inteiro em vez de trocar o componente a quente) e
 * rendia o aviso `react-refresh/only-export-components`. Como o mapa é lido
 * por três telas (card do equipamento, formulário de adicionar e
 * detalhamento do passo 4), o lugar dele é um módulo próprio.
 *
 * O motor tem o mesmo de-para no cadastro de Modalidades (`modality.name`),
 * que é a fonte da apólice; aqui a cópia existe porque o Portal precisa do
 * rótulo antes de qualquer chamada — e as duas mudam juntas.
 */
export const MODALITY_LABELS: Record<RdModalitySlug, string> = {
  estacionario: 'Estacionário',
  movel: 'Móvel',
  portatil: 'Portátil',
};
